import styled from "@emotion/styled";
import { Col, Row, Space } from "antd";
import { DatePicker } from "antd";
import { FC, useState } from "react";
import dayjs from "dayjs";
import TableInProgress from "./TableInProgress";
import TablePendingPayment from "./TablePendingPayment";
import TableBatchSummary from "./TableBatchSummary";
import TableCompletedSummary from "./TableCompletedSummary";

interface BangbowOrderProps {
  activeTable: "pendingPayment" | "inProgress" | "batchSummary" | "completedSummary";
}

const { RangePicker } = DatePicker;

const BangbowOrder: FC<BangbowOrderProps> = ({ activeTable }) => {
  const [startDate, setStartDate] = useState(
    dayjs().startOf("year").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));

  return (
    <WrapperAll>
      {/* <HeadWrapper>
        <Row gutter={[16, 16]} style={{ width: "100%" }} justify="space-between">
          <Col>
            <Space.Compact>
              <RangePicker
                format="DD-MM-YYYY"
                value={[dayjs(startDate), dayjs(endDate)]}
                onChange={(value) => {
                  if (value && value[0] && value[1]) {
                    setStartDate(value[0].format("YYYY-MM-DD"));
                    setEndDate(value[1].format("YYYY-MM-DD"));
                  }
                }}
              />
            </Space.Compact>
          </Col>
        </Row>
      </HeadWrapper> */}

      <Row gutter={[16, 16]} style={{ overflow: "auto", backgroundColor: "#EFEFEF" }}>
        {activeTable === "inProgress" && (
          <TableInProgress startDate={startDate} endDate={endDate} />
        )}
        {activeTable === "pendingPayment" && (
          <TablePendingPayment startDate={startDate} endDate={endDate} />
        )}
        {activeTable === "batchSummary" && <TableBatchSummary />}
        {activeTable === "completedSummary" && <TableCompletedSummary />}
      </Row>
    </WrapperAll>
  );
};

export default BangbowOrder;

const WrapperAll = styled.div`
  padding: 10px 10px 10px 8px;
  background-color: #efefef;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
